import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
  fullWidth?: boolean;
  scrollTo?: string;
}
export function Button({
  children,
  className = '',
  fullWidth = false,
  scrollTo,
  ...props
}: ButtonProps) {
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (scrollTo) {
      document.getElementById(scrollTo)?.scrollIntoView({
        behavior: 'smooth'
      });
    }
    props.onClick?.(e);
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`
        bg-amber-600 hover:bg-amber-700 text-white 
        font-bold text-xl md:text-2xl 
        py-4 px-8 rounded-xl shadow-[0_8px_30px_rgb(217,119,6,0.3)]
        transition-colors duration-300
        ${fullWidth ? 'w-full' : 'w-full md:w-auto'}
        ${className}
      `} {...props} onClick={handleClick} data-id="element-194">
      {children}
    </motion.button>;
}